import { attach, createEvent, createStore, sample } from 'effector'
import type { AnalytixParams } from '~/shared/analytix'
import { Analytix } from '~/shared/analytix'
import { logErrorFx } from './lib'

/**
 * Runtime configuration entrypoint for the shared Analytix adapter.
 */
export const initialize = createEvent<AnalytixParams>()

export const enable = createEvent()

export const disable = createEvent()

export const $analytix = createStore(new Analytix())

export const initializeFx = attach({
  source: $analytix,
  effect: (analytix, params: AnalytixParams) => analytix.initialize(params),
})

export const enableFx = attach({
  source: $analytix,
  effect: (analytix) => analytix.enable(),
})

const disableFx = attach({
  source: $analytix,
  effect: (analytix) => analytix.disable(),
})

/**
 * Adapter accepts sends only after {@link enable} (see {@link Analytix}).
 */
export const $analytixEnabled = createStore(false)
  .on(initialize, () => false)
  .on(enable, () => true)
  .on(disable, () => false)
  .on(initializeFx.fail, () => false)

sample({
  clock: initialize,
  target: initializeFx,
})

sample({
  clock: enable,
  target: enableFx,
})

sample({
  clock: disable,
  target: disableFx,
})

sample({
  clock: initializeFx.failData,
  fn: (fail) => fail,
  target: logErrorFx,
})
